import { Translatable } from '@icc/shared/helpers';

/** Boczek */
export class BlindSide {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    description: string;
    weight: number;
    /** Kolejność */
    order: number;
}